import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import 'moment/locale/es';
import useNow from './../hooks/useNow';
import { IUsuario } from '../pages/interfaces';
import { parseJwt } from '../utils/functions';

const Header = () => {
    const now = useNow();
    const jwt = localStorage.getItem("jwt");
    const usuario: IUsuario = parseJwt(jwt || "");

    return (
        <header>
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <div style={{padding: 15}}>
                        <img src={require('./../assets/images/isset-logo.png')} alt="ISSET Logo" style={{width: 150}} />
                    </div>
                </Grid>
                <Grid item xs={6}>
                    <div style={{padding: 15, display: "flex", justifyContent: "flex-end"}}>
                        <img src={require('./../assets/images/infoisset-logo.png')} alt="InfoISSET Logo"/>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="subtitle1">
                        Bienvenido(a) {usuario.nombre}. <strong>{now}</strong>.
                    </Typography>
                </Grid>
            </Grid>
        </header>
    );
};

export default Header;
